import { LEARNING_MODE } from 'Context/ClassroomContext';

/**
/**
 * Reorder "DEFAULT" mode to be the first index
 *
 * @param {Array} learningModeDetailOptions - An array of learningModeDetailOption.
 * @returns {Array} The sorted array that has the first index is "DEFAULT" mode.
 */
export const setDefaultModeToBeTheFirstIndex = (learningModeDetailOptions) => {
  const learningModes = [...learningModeDetailOptions];
  const defaultModeIndex = learningModes.findIndex(
    (learningModeDetailOption) => learningModeDetailOption.id === LEARNING_MODE.DEFAULT
  );

  const defaultMode = learningModes.splice(defaultModeIndex, 1);

  return [...defaultMode, ...learningModes];
};
